
export enum ScreenType {
  BASIC = 'BASIC',
  PREMIUM = 'PREMIUM'
}